namespace pixi_ui.component {
    import Sprite = PIXI.Sprite;
    import Texture = PIXI.Texture;

    export class Image implements IComponent {
        public antialiasing: boolean;
        public dontScaleOnClick: boolean;
        public imageSprite: Sprite;

        constructor(texture: Texture) {
            this.imageSprite = new Sprite(texture);
        }

        public attach(element: Element): void {
            element.desiredWidth = this.imageSprite.width;
            element.desiredHeight = this.imageSprite.height;
            element.addChild(this.imageSprite);
        }

        public detach(element: Element): void {
            element.removeChild(this.imageSprite);
        }

        public resize(element: Element): void {
            this.imageSprite.width = element.elementWidth;
            this.imageSprite.height = element.elementHeight;
        }
    }
}
